import editorRule from '@/components/atoms/editorRule'
import { PortableText } from 'next-sanity'

const Title = ({ text }) => {
  const base = 'content relative w-full text-left md:text-center text-headingCardsMobile md:text-subheadingDesktop text-umber font-ttDrugsTrial'

  return (
    <div className={base}>
      <PortableText value={text} components={editorRule('secondary')} />
    </div>
  )
}

export default Title
